import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProductCategory, ViewProductColours } from '../../_models/index';
import { PageService, } from '../../_services/index';
import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-product-sectors-colours',
    templateUrl: './product-sector-colours.component.html',
    styleUrls: ['./product-sector-colours.component.scss'],
    standalone: false
})
export class ProductSectorColoursComponent implements OnInit, OnDestroy {
    public categories: ProductCategory[] = [];
    public loading = true;
    public sectorName: string = null;
    public webSectorID: number = null;
    public productColours: ViewProductColours[];
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    constructor (
        private title: Title,
        private route: ActivatedRoute,
        private solentProductService: PageService,
        private pageService: PageService) {
            this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
                const sectorID = params.sector;
                this.webSectorID = params.sector;
                this.getProducts(sectorID);
            });
         }


    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    ngOnInit () {
        this.title.setTitle('Solent Wholesale | Product Sectors');
        this.fetchCateogires();
    }

    fetchCateogires () {
        this.pageService.getCategories(false).pipe(
            take(1),
            takeUntil(this.ngUnsubscribe))
            .subscribe(x => this.categories = x);
    }

    getProducts(sectorID) {
        this.loading = true;
        this.solentProductService.getColoursBySector(sectorID)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(products=> {
                this.loading = false;
                this.sectorName = products.sector;
                this.productColours = products.colours;  // all products
            });
    }

    imageCheck(image) {
        if (image === null ) {
            return 'https://swc-website.s3-eu-west-1.amazonaws.com/static_images/no_photo.jpg';
        } else {
            return image;
        }
    }


}
